import React from 'react';
import { mdiHelpCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { observer } from 'mobx-react';
import { Modal, ModalHeader, ModalFooter, ModalBody, Container } from 'reactstrap'; 

import { InformationModalIcon } from './InformationModal'; 

interface IInfoElemModalProps {
    showHelpModal: boolean;
    closeHelpModal;
    helpModalTitle: string;
    helpModalContent: any; 
}

const InfoElemModalComponent = (props: IInfoElemModalProps) => {
    return (
        <Modal
        isOpen={props.showHelpModal}
        toggle={props.closeHelpModal}
        centered={true}
        className="eft-action-modal"
        aria-label={props.helpModalTitle}
        >
        <ModalHeader toggle={props.closeHelpModal} className='header-info-detail' >
          <div className="display-flex flex-align-center">
            <strong >{`Information details on ${props.helpModalTitle}`}</strong>
          </div>
        </ModalHeader>
        <ModalBody>
          <Container>
            {props.helpModalContent}
          </Container>
        </ModalBody>
        <ModalFooter>
          <button className="usa-button usa-button--outline" onClick={props.closeHelpModal}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    )
}

export const InformElementModal = observer(InfoElemModalComponent);